import React from 'react';
import { TableColumn } from '../../../types/search';
import DynamicTable from './DynamicTable';
import SvgIcon from '../../utils/SvgIcon';

interface PortalListingSearchResultsContainerProps {
  columns: TableColumn[];
  rows: Record<string, unknown>[];
  onSortChange?: (newSortOrder: string, newSortCol: string) => void;
  isLoading?: boolean;
  noResultsText?: string;
  sortOrder?: string;
  sortCol?: string;
  listingType?: string;
  selectedRows?: string[];
  setSelectedRows?: React.Dispatch<React.SetStateAction<string[]>>;
  isPaginationActive?: boolean;
}

const PortalListingSearchResultsContainer: React.FC<PortalListingSearchResultsContainerProps> = ({
  columns,
  rows,
  onSortChange,
  isLoading,
  noResultsText,
  sortOrder,
  sortCol,
  listingType,
  selectedRows,
  setSelectedRows,
  isPaginationActive,
}) => {
  const showSelectionWarning = isPaginationActive && listingType === 'invoices' && selectedRows?.length > 0;

  if (isLoading) return <div>Loading...</div>;
  if (!rows || rows.length === 0) return <div>{noResultsText || 'No results found.'}</div>;
  return (
    <div className="content-grid-block__grid documents__results-grid">
      <DynamicTable
        columns={columns}
        rows={rows}
        onSortChange={onSortChange}
        sortOrder={sortOrder}
        sortCol={sortCol}
        listingType={listingType}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
      {showSelectionWarning && (
        <div className="portal__warning selection-warning">
          <SvgIcon iconName="warning" additionalClasses="portal__warning-icon" aria-hidden="true" />
          <p className="portal__warning-text">Moving to a new page will clear your current selection.</p>
        </div>
      )}
    </div>
  );
};

export default PortalListingSearchResultsContainer;
